import React from "react";
import { CashbackCustomerProductView } from "../assets/assets";
import "../styles/button.css";
import { sendSlackMessage } from "../models/notifications";

const BENEFITS = [
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5zm-1 10.56L5.22 9.28l1.06-1.06L8 9.94l4.72-4.72 1.06 1.06L8 12.06z" fill="#16a34a"/>
      </svg>
    ),
    text: "Customers earn a percentage back on each purchase. Pabloo adds the credit to their account automatically.",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5zm-1 10.56L5.22 9.28l1.06-1.06L8 9.94l4.72-4.72 1.06 1.06L8 12.06z" fill="#16a34a"/>
      </svg>
    ),
    text: "The credit balance grows with each order. Customers who buy more return more often.",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5zm-1 10.56L5.22 9.28l1.06-1.06L8 9.94l4.72-4.72 1.06 1.06L8 12.06z" fill="#16a34a"/>
      </svg>
    ),
    text: "You set the rate, the triggers, and the expiry rules. You do not need engineering help to do this.",
  },
  {
    icon: (
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9s3.36 7.5 7.5 7.5 7.5-3.36 7.5-7.5S13.14 1.5 9 1.5zm-1 10.56L5.22 9.28l1.06-1.06L8 9.94l4.72-4.72 1.06 1.06L8 12.06z" fill="#16a34a"/>
      </svg>
    ),
    text: "Pabloo merchants see a 4× increase in repeat purchases.",
  },
];

const IntegrationsComponent = () => {
  return (
    <section className="integrations-section">
      <div className="integrations-wrapper">

        {/* Image */}
        <div className="rounded-2xl flex items-center image-size-wrapper">
          <img
            src={CashbackCustomerProductView}
            alt="Pabloo cashback customer view"
            className="shadow-2xl flex justify-center items-center image-size rounded-2xl"
          />
        </div>

        {/* Text */}
        <div className="integrations-text-wrapper">

          {/* Eyebrow */}
          <div
            style={{
              display:      "inline-flex",
              alignItems:   "center",
              gap:          "7px",
              background:   "rgba(22,163,74,0.08)",
              border:       "1px solid rgba(22,163,74,0.25)",
              borderRadius: "99px",
              padding:      "5px 14px",
              marginBottom: "20px",
            }}
          >
            <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#16a34a", flexShrink: 0 }} />
            <span style={{ fontSize: "0.8125rem", fontWeight: 600, color: "#16a34a", fontFamily: "'DM Sans', system-ui, sans-serif", letterSpacing: "0.01em" }}>
              Cashback
            </span>
          </div>

          <h2 className="heading-56px integrations-heading">
            Cashback that{" "}
            <span className="pink-heading-span" style={{ color: "#15803d" }}>
              brings them back.
            </span>
          </h2>

          <p className="paragraph-18px integrations-paragraph">
            Cashback turns one-time buyers into repeat customers. No sale needed. Each purchase puts credit back in the customer account. The customer uses that credit on the next order. The cycle runs on its own.
          </p>

          <ul style={{ listStyle: "none", padding: 0, margin: "24px 0 32px", display: "flex", flexDirection: "column", gap: "14px" }}>
            {BENEFITS.map((b, i) => (
              <li key={i} style={{ display: "flex", alignItems: "flex-start", gap: "10px", fontFamily: "'DM Sans', system-ui, sans-serif", fontSize: "0.9375rem", color: "#374151", lineHeight: 1.6 }}>
                <span style={{ marginTop: "2px", flexShrink: 0 }}>{b.icon}</span>
                {b.text}
              </li>
            ))}
          </ul>

          <a
            href="https://app.pabloo.com/sign-up"
            target="_self"
            className="transparent-arrow-button w-inline-block"
            onClick={() => {
              sendSlackMessage("Someone has clicked on 'Start earning cashback' from the Cashback section.", "#website-updates");
              window.gtag?.("event", "conversion_button_clicked", {
                button: "view_shopify_listing",
                source: "Cashback section",
              });
            }}
          >
            <div className="button-panels-contain">
              <div className="button-panel" />
            </div>
            <div className="button-text-wrapper">
              <div className="button-text trans">Start earning cashback</div>
              <div className="button-arrow-embed _18px trans w-embed">
                <svg width={10} height={17} viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2 2L8.75 8.75L2 15.5" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
            </div>
          </a>

        </div>
      </div>
    </section>
  );
};

export default IntegrationsComponent;
